export default __webpack_public_path__ + "static/media/cop3.d0536f98.png";